import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ContentHomeSliderItem pattern-slider-item" }
const _hoisted_2 = {
  width: "560",
  height: "580",
  viewBox: "0 0 560 580",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  class: "pattern-slider-item__svg"
}
const _hoisted_3 = ["id"]
const _hoisted_4 = ["d"]
const _hoisted_5 = ["mask"]
const _hoisted_6 = ["width", "height", "fill"]
const _hoisted_7 = ["id"]
const _hoisted_8 = ["xlink:href", "transform"]
const _hoisted_9 = ["id", "href", "transform-origin"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("mask", {
        id: `mask0_388_7542-2-${_ctx.id}`,
        style: {"mask-type":"alpha"},
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "560",
        height: "580"
      }, [
        _createElementVNode("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: _ctx.tablet ? _ctx.MOBILE_MASK_PATH : _ctx.DESKTOP_MASK_PATH,
          fill: "#D9D9D9"
        }, null, 8, _hoisted_4)
      ], 8, _hoisted_3),
      _createElementVNode("g", {
        mask: `url(#mask0_388_7542-2-${_ctx.id}`
      }, [
        _createElementVNode("rect", {
          width: _ctx.tablet ? '400' : '560',
          height: _ctx.tablet ? '450' : '580',
          fill: `url(#pattern0-${_ctx.id})`
        }, null, 8, _hoisted_6)
      ], 8, _hoisted_5),
      _createElementVNode("defs", null, [
        _createElementVNode("pattern", {
          id: `pattern0-${_ctx.id}`,
          patternContentUnits: "objectBoundingBox",
          width: "1",
          height: "1",
          class: _normalizeClass(["pattern-use", { 'is--safari': _ctx.safari }]),
          style: _normalizeStyle({ '--transform-scale': `scale(1.${_ctx.scale})` })
        }, [
          _createElementVNode("use", {
            "xlink:href": `#image0_388_7542-${_ctx.id}`,
            transform: _ctx.tablet ? `translate(0.01 0) scale(0.0012)` : `translate(0 0) scale(0.0014)`
          }, null, 8, _hoisted_8)
        ], 14, _hoisted_7),
        _createElementVNode("image", {
          id: `image0_388_7542-${_ctx.id}`,
          class: "pattern-slider-item__image",
          width: "660",
          height: "680",
          href: _ctx.imagePath,
          "transform-origin": _ctx.tablet ? '150 150' : '200 200'
        }, null, 8, _hoisted_9)
      ])
    ]))
  ]))
}